<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 14 15`"
    :width="getWidth"
  >
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
      <g id="Mobile-Home" transform="translate(-133.000000, -141.000000)" stroke="#999999" stroke-width="1.33333333">
        <g id="Group-2" transform="translate(119.000000, 129.000000)">
          <g id="calendar-(1)" transform="translate(15.000000, 13.000000)">
            <rect id="Rectangle" x="0" y="1.33333333" width="12" height="12" rx="1.33333333"></rect>
            <line x1="8.66666667" y1="0" x2="8.66666667" y2="2.66666667" id="Path"></line>
            <line x1="3.33333333" y1="0" x2="3.33333333" y2="2.66666667" id="Path"></line>
            <line x1="0" y1="5.33333333" x2="12" y2="5.33333333" id="Path"></line>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-calendar'

  export default {
    name: 'SvgIconCalendar',
    mixins: [ bem ],
    props: {
      height: {
        default: '14',
        type: String
      },
      width: {
        default: '15',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.setNamespace(namespace)
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconCalendar.vue